import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { SharedModule } from '@ddt-web/common';
import { DomService } from '@ddt-web/dom';
import { SessionStorageKey } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

import { PreviewDataBannerComponent } from './preview-data-banner.component';

@NgModule({
	declarations: [PreviewDataBannerComponent],

	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		DzButtonModule,
		DzIconModule.withIcons(faPlus, faMinus)
	],
	exports: [PreviewDataBannerComponent]
})
export class PreviewDataBannerModule {
	constructor(private domService: DomService) {
		const parsedUrl = new URL(window.location.href);
		const showPasPreviewBanner =
			parsedUrl.searchParams.get(SharedQueryParamKey.PAS_PREVIEW) ||
			parsedUrl.searchParams.get(SharedQueryParamKey.PAS_AS_OF_DATE) ||
			sessionStorage.getItem(SessionStorageKey.PAS_AS_OF_DATE);

		if (showPasPreviewBanner) {
			this.domService.prependComponentToBody(PreviewDataBannerComponent);
		}
	}
}
